module.exports = __webpack_public_path__ + "img/smart.3b0ce025.svg";